import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import color from "../utils/Colors";

interface FeeCollectionCardProps {
  feetype: string;
  totalAmount: number;
  percentageIncrease: number;
}

const FeeCollectionCard: React.FC<FeeCollectionCardProps> = ({
  feetype,
  totalAmount,
  percentageIncrease,
}) => {
  return (
    <Card
      sx={{
        backgroundColor: color.firstColor,
        color: "white",
        borderRadius: 4,
        width: 320,
        padding: 2,
      }}
    >
      <CardContent>
        <Typography variant="h5" gutterBottom fontWeight={"bold"}>
          {feetype} Fee Collection
        </Typography>

        <Box display="flex" alignItems="center" gap={2} mt={2}>
          <Box
            sx={{
              backgroundColor: color.forthColor,
              borderRadius: "50%",
              padding: 1.5,
              display: "flex",
              alignItems: "center",
            }}
          >
            <CurrencyRupeeIcon sx={{ fontSize: 36, color: "white" }} />
          </Box>
          <Typography variant="h4" fontWeight="bold">
            {totalAmount}
          </Typography>
        </Box>

        <Box mt={3}>
          <LinearProgress
            variant="determinate"
            value={percentageIncrease}
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#8C52FF",
              },
            }}
          />
        </Box>

        <Typography variant="body2" align="left" sx={{ mt: 1 }}>
          {percentageIncrease}% Increase in 30 Days
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FeeCollectionCard;
